
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

export async function fetchStagnantInstruments() {
    try {
        const res = await fetch('/api/stagnant-instruments/get-all');
        const data = await res.json();
        // Normalize just in case: your useEffect maps over it
        return Array.isArray(data) ? data : [];
    } catch (err) {
        console.error('Error fetching Stagnant instruments:', err);
        return [];
    }
}
